class TOSConfiguratorIntro {
  constructor(section) {
    this.section = section;
    this.hasPlayed = false;
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.prefersReducedMotion) {
      this.showFinalState();
      return;
    }

    this.observe();
  }

  observe() {
    if (!('IntersectionObserver' in window)) {
      this.play();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.38) {
            this.play();
            this.observer.disconnect();
          }
        });
      },
      { threshold: [0, 0.38, 1] }
    );

    this.observer.observe(this.section);
  }

  play() {
    if (this.hasPlayed) return;
    this.hasPlayed = true;
    this.section.classList.add('is-active');
  }

  showFinalState() {
    this.section.classList.add('is-reduced-motion', 'is-active');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-tos-configurator]').forEach((section) => {
    new TOSConfiguratorIntro(section);
  });
});
